import React from 'react';
import { Box, useColorMode } from '@chakra-ui/react';
import { CopyBlock, dracula, atomOneLight } from 'react-code-blocks';
import { borderColor } from './const';

interface ICodeBlockProps {
	text: string;
	language: string;
	showLineNumbers?: boolean;
	wrapLines?: boolean;
}

const CodeBlock = ({ text, language, showLineNumbers, wrapLines }: ICodeBlockProps) => {
	const { colorMode } = useColorMode();
	return (
		<Box border="1px" borderColor={borderColor[colorMode]} borderRadius="sm">
			<CopyBlock
				language={language}
				text={text}
				showLineNumbers={!showLineNumbers ? true : showLineNumbers}
				theme={colorMode === 'dark' ? dracula : atomOneLight}
				wrapLines={!wrapLines ? true : wrapLines}
				codeBlock
			/>
		</Box>
	);
};

CodeBlock.defaultProps = {
	showLineNumbers: true,
	wrapLines: true
};

export default CodeBlock;
